import { Component } from '@angular/core';

import { CustomPageBlockComponent } from './custom-page-block.component';

/**
 * Display an unordered list with the specified items.
 */
@Component({
  selector: 'app-custom-page-unordered-list',
  template: `<div class="max-w-screen-lg mx-auto px-8">
    <ul class="list-disc list-outside">
      @for (child of data().content; track $index) {
        <li>{{ child }}</li>
      }
    </ul>
  </div>`,
  standalone: true,
})
export class CustomPageUnorderedListComponent extends CustomPageBlockComponent<'unordered_list'> {}
